<template>
  <div class="container">
    <!-- <HeaderCoursesComponent class="mb-4" /> -->
    <!-- Loading -->
    <LoadingComponent v-if="is_loading" />
    <!-- Error -->
    <ErrorComponent v-else-if="error && !is_loading" :error="error" />
    <!--  Data -->
    <template v-else>
      <div class="courses-container">
        <LoadingComponent v-if="is_loading" />
        <template v-if="!is_loading">
          <CourseCardComponent
            v-for="(item, index) in student_courses"
            :key="index"
            class="col-lg-4 col-md-6 col-12"
            :data="item"
            :subscribed="true"
          />
        </template>
        <p v-if="student_courses.length == 0 && !is_loading" class="no-content">
          مفيش كورسات أنت مشترك فيها لحد دلوقتي
        </p>
        <PaginationBtns
          v-if="student_courses.length > 0"
          :next="hav_next"
          :prev="hav_prev"
          :link="'bills'"
        />
      </div>
    </template>
  </div>
</template>

<script>
import LoadingComponent from "@/components/Loading/LoadingComponent.vue";
import ErrorComponent from "@/components/Error/ErrorComponent.vue";
// import HeaderCoursesComponent from "../HeaderCourses/HeaderCoursesComponent.vue";
import CourseCardComponent from "../CourseCard/CourseCardComponent.vue";
import axios from "axios";
import config from "@/services/config";
import PaginationBtns from "@/components/PaginationBtns/PaginationBtns.vue";
import { watchEffect } from "vue";

export default {
  name: "CoursesComponent",
  components: {
    // HeaderCoursesComponent,
    CourseCardComponent,
    LoadingComponent,
    ErrorComponent,
    PaginationBtns,
  },
  data() {
    return {
      student_courses: [],
      is_loading: true,
      error: null,
      hav_next: false,
      hav_prev: false,
    };
  },
  methods: {
    getCourses() {
      axios
        .get(`${config.basURL}student/course-subscription-list`, {
          headers: {
            auth: this.$store.state.userToken,
          },
        })
        .then((res) => {
          this.student_courses = res.data.results;
        })
        .catch((err) => {
          this.error = err?.response?.status
            ? err.response.status
            : err.message;
          console.log(err.message);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
  created() {
    watchEffect(() => {
      this.getCourses();
    });
  },
};
</script>

<style scoped>
.courses-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  row-gap: 2rem;
  column-gap: 0rem;
}

.no-content {
  padding: 1rem 0.8rem;
  font-size: 1.3rem;
  font-weight: bold;
  text-align: center;
  width: 100%;
  color: #1e1e1e;
}
body.dark .no-content {
  color: #fff;
}

/* Dark Mode */
/*  Media queries */
@media screen and (max-width: 992px) {
  .courses-container {
    justify-content: center;
  }
}
</style>
